module.exports = "/static/assets/82e2890b48df96037aeb0e965cdd1cee.gif";